import React, { Component } from 'react'
import { connect } from 'react-redux'
class OrderEventResult extends Component {
  clearSearch () {
    this.props.dispatch({
      type: 'SET_SEARCH',
      payload: {
        query: '',
        total: 0,
        results: false
      }
    })
    return true
  }
  render () {
    return (
      <a key={'result' + this.props.result.id} onClick={e => this.clearSearch()} href={'#/access/' + this.props.result.order.accessId} className={'list-group-item ' + (this.props.active ? 'active list-group-item-active' : '')} >
        <div className='search-icon-wrapper'>
          <i className={'fa fa-fw fa-sliders'} />
        </div>
        <div className='flow-search-result-wrapper'>
          <h4 className='list-group-item-heading'>{this.props.result.order.service + ' ' + this.props.result.order.spReference} <small>{this.props.result.operation}</small></h4>
          <p className='list-group-item-text'>{this.props.result.timestamp + ' ' + (this.props.result.order.state || '')}</p>
        </div>
      </a>
    )
  }
}

// eslint-disable-next-line
OrderEventResult = connect(state => state.siteReducer)(OrderEventResult)
export default OrderEventResult



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/core/search/OrderEventResult.js